import { NormalizedNumber, UnixTimestamp } from '@sparkdotfi/common-universal'
import { QueryKey } from '@tanstack/react-query'
import { z } from 'zod'

import { Proposal } from '../types'

export function governanceProposalsQueryKey(): QueryKey {
  return ['spk-governance', 'proposals']
}

export async function governanceProposalsQueryFn(): Promise<Proposal[]> {
  const res = await fetch('https://hub.snapshot.org/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
      query Proposals($where: ProposalWhere) {
       proposals(where: $where) {
        start
        end
        votes
        title
        link
       }
      }
     `,
      variables: {
        where: {
          space: 'sparkfi.eth',
          state: 'active',
        },
      },
    }),
  })

  if (!res.ok) {
    throw new Error('Failed to fetch proposals')
  }

  const data = await res.json()
  const parsed = proposalsSchema.parse(data)

  return parsed.data.proposals
}

const proposalsSchema = z.object({
  data: z.object({
    proposals: z.array(
      z
        .object({
          start: z.number(),
          end: z.number(),
          votes: z.number(),
          title: z.string(),
          link: z.string(),
        })
        .transform((data) => ({
          votes: NormalizedNumber(data.votes),
          start: UnixTimestamp({ seconds: data.start }),
          end: UnixTimestamp({ seconds: data.end }),
          voteLink: data.link,
          title: data.title,
        })),
    ),
  }),
})
